import React from 'react';
import SharedHeader from './SharedHeader';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  noPadding?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, maxWidth = 'max-w-4xl', noPadding = false }) => (
  <div className="min-h-screen bg-surface text-ink flex flex-col">
    <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-brand-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg">
      Skip to content
    </a>
    <SharedHeader />
    <main id="main-content" tabIndex={-1} className={noPadding ? 'min-w-0 flex-1' : 'min-w-0 flex-1 py-8 sm:py-10 px-4 sm:px-6 lg:px-8'}>
      {noPadding ? children : (
        <div className={`${maxWidth} mx-auto`}>
          {children}
        </div>
      )}
    </main>
    <div className="mt-12 border-t border-surface-border bg-white px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <Footer />
      </div>
    </div>
  </div>
);

export default Layout;
